import { render, staticRenderFns } from "./area-range.md?vue&type=template&id=8e3efcb2&"
import script from "./area-range.md?vue&type=script&lang=js&"
export * from "./area-range.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e3efcb2')) {
      api.createRecord('8e3efcb2', component.options)
    } else {
      api.reload('8e3efcb2', component.options)
    }
    module.hot.accept("./area-range.md?vue&type=template&id=8e3efcb2&", function () {
      api.rerender('8e3efcb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Area/area-range.md"
export default component.exports